import { UserActivityLogModel } from "../../models/userActivityLog.model";
import { sequence } from "@angular/animations";
import { ChildProcessWithoutNullStreams } from "child_process";
import { EntityField } from "src/app/create/models/entity.model";
import { v4 as uuidv4 } from 'uuid';
import { ICustomAttribute } from "../../models/customAttribute.model";
import { Editor } from "ngx-editor";

export class PreBuiltAnswers{
  id: number;
  key: string;
  values: string[] =[];
}
export class CreateSurvey {
  surveyId: string;
  name: string;
  status: string;
  description: string;
  resultsCount: number;
  isFavourite: boolean;
  isEsignReq:boolean;
  isWorkflow:boolean;
  isWfPublished:boolean;
  isLiked: boolean;
  categoryName: string;
  colorScheme: string;
  eSignConsentText:string;
  isLoginRequired : boolean ;
  isOverdueAccessAllowed:boolean;
  redirectionUrl: string;
  surveyType: string;
  logoFormat: string;
  logoImage: string;
  logoSize: number;
  surveyAdmins: SurveyAdmins[];
  sections: QuestionAnswer[];
  createdDate:Date;
  surveyGroupName: string;
  surveyGroupId: string;
  dueDaysCount:number;
  dueDate:Date;
  isMultipleResponseAllowed:boolean=true;
  isOverdue:boolean=true;
  userActivityLog? : UserActivityLogModel;
  businessProcessID:string;
  entityId: string;
  organizationId: string;
  mappingKey: string;
}
export class SurveyAdmins {
  fullName: string;
  userId: string;
}


export class QuestionAnswer {
  sectionGuid:string=null;
  sectionId?:number;
  pageSectionRelId?:number;
  parentSectionGuid:string=null;
  parentSectionId:number;
  parentQuestionGuid:string=null;
  parentQuesResponse?: string = null;
  //showHideChild: boolean;
  hasValidation: boolean ;
  gridQuestions:GridQuestion[]= [];
  sectionName: string = null;
  isExpanded: boolean = null;
  questions: Question[];
  isMenuVisible: boolean = true;
  sequenceNumber?: number = 1;
  sectionDescription?: string = null;
  sectionToolTip?: string = null;
  isDeleted: boolean = false;
  subQuestionRelId? :number=0;

  isSectionSelected :boolean;
  workflowStepSectionAccessLevel :string;
  sectionDotColor:string =null;

  isLookUpSection:boolean = false;
  //searchlookUpList :EntityField[]=[];
  sectionLookUpEntityId :string =null;
  isSecParentQuestionVisible :boolean;

  constructor(title, ques,sectionGuid,sequenceNumber) {
    this.sectionGuid=sectionGuid;
    this.sectionName = title;
    this.isExpanded = false;
    this.questions = ques;
    this.isMenuVisible = false;
    this.sequenceNumber=sequenceNumber;
  }
}

export class GridQuestion{
  questions:Question[];
  gridId?:number;
  description?:string;
  sequenceNumber?:number;
  isExpanded: boolean = false;
  isMenuVisible: boolean = false;
  isDeleted:boolean=false;

}

export class Question {
  questionId?: number;
  sequenceNumber?: number = 1;
  questionTextShort?: string;
  isQuestionRequired?: string = null;
  questionText: string;
  questionRichEditorText?: string;
  backupRichEditorText?: string = null;
  dataType: string;
  inputType: string = null;
  refTableName?: string = "Survey Questions";
  questionToolTip?: string = "";
  parentQuestionId?: number;
  parentQuesResponse?: string = null;
  defaultResponse?: string = null;
  maxLength?: number = null;
  isMaxLength: boolean = false;
  sectionId?: number = null;
  gridId?:number=null;
  isExpanded: boolean = true;
  questionImage?: (string | ArrayBuffer);
  questionImageName?: string = null;
  options?: OptionsInfo[];
  editQuestion: boolean = true;
  validations: number[] = [];
  isValidation: boolean;
  subQuestions:Question[]=[];
  isDeleted: boolean = false;
  futureDateEnabled?: boolean = true;
  pastDateEnabled?:boolean = true;
  todayDateEnabled?:boolean = true;
  timeEnabled?:boolean=false;
  displayMode: string = "SH";
  questionGuid:string=null;
  enableQuestion : boolean = false;
  comments:string=null;
  questionType?:any;
  entityFieldId?: string=null;
  parentQuestionGuid:string=null;
  isPrebuiltAnswer?: boolean = false;
  isPrebuiltAnswerId?: number = 0;
  lookUpEntityFieldDisable :boolean = false;
  //entityFieldDisable :boolean = false;
  lookUpQuestionId : number;
  isFieldQuestion :boolean = false;
  questionAttributes : ICustomAttribute[] = [];
  isFileConfig?: boolean = false;
  questionFileConfig: QuestionFileConfig = new QuestionFileConfig();
  isLabel: boolean;
  isConsentQuestion: boolean = false;
  consentQuestionLabel: string = '';
  questionSignTypes: string[] = [];
  isESignRequired: boolean = false;
  isSSignRequired: boolean = false;

  constructor(title, tag, type,questionGuid,sequenceNumber) {
    this.questionGuid=questionGuid;
    this.questionText = title;
    this.questionRichEditorText = title;
    this.questionTextShort = tag;
    this.dataType = type;
    this.isExpanded = false;
    this.sequenceNumber=sequenceNumber;
    this.options = [{
      value: '',
      sequenceNumber:1,
      optionGuid : uuidv4()
      //selected:false
    }];
    this.validations = [];
    this.questionImage = '';
    this.editQuestion = false;
    this.isValidation = false;
    this.isFileConfig = false;
    this.questionFileConfig = new QuestionFileConfig();
  }
}

export class SubQuestion{
  //subQuestions:Question[];
  questionId?:number;
  questionGuid:string;
  subQuestionGuid:string;
  subQuestionId?:number;
  subQuestion:Question;
  sequenceNumber?:number;
  isExpanded: boolean = false;
  isMenuVisible: boolean = false;
  isDeleted:boolean=false;
  question:Question;
  entityFieldId?: string="";

}

export class QuestionFileConfig {
  fileType: string = "";
  fileSizeLimitValue: number = 0;
  fileSizeLimitUnit: string = "";
  fileExtensions: string[] = [];
  fileNameRegex: string = "";
  fileNameRegexErrorMessage: string = "";
  isMultiFileSelection: boolean = false;
  isSecuredFile:boolean = false;
}

export class OptionsInfo {
  key?: string;
  value: string;
  sequenceNumber:number;
  //selected?: boolean;
  questionOptionId? : number;
  optionGuid? : string;
  //parentOptionGuid? : string;
  optionMappings? : OptionMappings[];
  optionType?: string;
}



export class OptionMappings {
  questionOptionId : number;
  optionGuid? : string;
  parentOptionGuid : string;
}

export class QuestionType {
  icon: string;
  title: string;
  description: string;
  colorCode: string;
  type: string;
}

export class ValidationData {
  title: string;
  validationId: number;
}

export class SelectedQuestionData {
  isSettingPanelOpened:boolean;
  isSectionSelected:boolean;
  selectedCard: Question;
  selectedSection: QuestionAnswer;
  questions: QuestionAnswer[];
}


export class FileUploadQuestion
{
  questionId?:number;
  files:FileDetail[];
}

export class FileDetail
{
id:string;
file:File;
name:string;
size:string;
base64String:any;
sequence:number;
isLoading:boolean=false;
isFinished:boolean=false;
isGood:boolean=true;
filePath:string;
}
export const qTypes = [
  {
    icon: '',
    title: 'Multiple Choice',
    description: 'This is multiple choice Screen',
    colorCode: '#287cc4',
    type: 'multipleChoice'
  }, {
    icon: '',
    title: 'Check Box',
    description: 'This is checkbox Screen',
    colorCode: '#8d45ff',
    type: 'checkbox'
  }, {
    icon: '',
    title: 'Radio Box',
    description: 'This is radio buttons Screen',
    colorCode: '#ff6945',
    type: 'radiobuttons'
  }, {
    icon: '',
    title: 'Dropdown',
    description: 'This is dropdown Screen',
    colorCode: '#ffa245',
    type: 'dropdown'
  }, {
    icon: '',
    title: 'Singleline TextBox',
    description: 'This is Textbox Screen',
    colorCode: '#35d770',
    type: 'textbox'
  }, {
    icon: '',
    title: 'Multiline TextBox',
    description: 'This is textarea Screen',
    colorCode: '#35d555',
    type: 'textarea'
  }, {
    icon: '',
    title: 'Rating',
    description: 'This is Rating Screen',
    colorCode: '#ff6945',
    type: 'rating'
  }, {
    icon: '',
    title: 'Date Picker',
    description: 'This is date picker Screen',
    colorCode: '#248A8C ',
    type: 'dte'
  },
  {
    icon: '',
    title: 'Grid',
    description: 'This is Grid Screen',
    colorCode: '#4b0082',
    type: 'table'
  },
  {
    icon: '',
    title: 'Signature',
    description: 'This is signature Screen',
    colorCode: '#000',
    type: 'signature'
  },
  {
    icon: '',
    title: 'File Upload',
    description: 'This is File Upload Screen',
    colorCode: '#615f98',
    type: 'fileupload'
  },
  {
    icon: '',
    title: 'Matrix',
    description: 'This is Matrix Screen',
    colorCode: '#0384fc',
    type: 'matrix'
  },
  {
    icon: '',
    title: 'Display Text',
    description: 'This is Display Text Screen',
    colorCode: '#0384fc',
    type: 'displaytext'
  },

]
